/* Delegated events also handle Shopify theme-editor section replacements. */
(() => {
  if (window.uhwProductGuarantee) return;
  window.uhwProductGuarantee = true;
  const openers = new Map();
  const dialogSelector = 'dialog[data-uhw-guarantee-dialog]';

  function restore(dialog) {
    const opener = openers.get(dialog);
    openers.delete(dialog);
    if (!document.querySelector(`${dialogSelector}[open]`)) {
      document.documentElement.classList.remove('uhw-guarantee-open');
    }
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  }

  function close(dialog) {
    if (dialog.open) dialog.close();
    restore(dialog);
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-uhw-guarantee-open]');
    if (trigger) {
      // Modified clicks keep the PDF link's normal browser behavior.
      if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const dialog = trigger.closest('[data-uhw-guarantee]')?.querySelector(dialogSelector);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      try {
        dialog.showModal();
      } catch (_) {
        return; // Preserve the original PDF link if opening fails.
      }
      event.preventDefault();
      openers.set(dialog, trigger);
      dialog.scrollTop = 0;
      document.documentElement.classList.add('uhw-guarantee-open');
      dialog.querySelector('[data-uhw-guarantee-close]')?.focus({ preventScroll: true });
      return;
    }
    const closeButton = event.target.closest('[data-uhw-guarantee-close]');
    if (closeButton) {
      const dialog = closeButton.closest(dialogSelector);
      if (dialog) close(dialog);
      return;
    }
    if (event.target.matches(dialogSelector) && event.target.open) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
        close(event.target);
      }
    }
  });

  // Keep Tab inside this dialog even where the browser otherwise focuses its chrome.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || !(event.target instanceof Element)) return;
    const dialog = event.target.closest(dialogSelector);
    if (!dialog?.open) return;
    const focusable = [...dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex], [contenteditable]')]
      .filter((element) => element.tabIndex >= 0 && !element.matches(':disabled')
        && !element.closest('[hidden], [inert]') && element.getClientRects().length > 0
        && !['hidden', 'collapse'].includes(getComputedStyle(element).visibility));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (!first || !focusable.includes(active) || (event.shiftKey ? active === first : active === last)) {
      event.preventDefault();
      (event.shiftKey ? last || dialog : first || dialog).focus();
    }
  }, true);

  document.addEventListener('cancel', (event) => {
    if (event.target instanceof Element && event.target.matches(dialogSelector)) {
      event.preventDefault();
      close(event.target);
    }
  }, true);

  // `close` does not bubble; capture also covers a native/form-driven close.
  document.addEventListener('close', (event) => {
    if (event.target instanceof Element && event.target.matches(dialogSelector)) restore(event.target);
  }, true);

  document.addEventListener('shopify:section:unload', (event) => {
    for (const dialog of openers.keys()) {
      if (event.target.contains(dialog)) close(dialog);
    }
  });
})();
